import posthog from 'posthog-js';
import { POSTHOG_API_HOST, POSTHOG_API_KEY, POSTHOG_DEFAULTS, POSTHOG_UI_HOST } from '@/common/config.ts';

let initialized = false;

export function usePostHog() {
  // Only initialize once
  if (!initialized) {
    posthog.init(POSTHOG_API_KEY, {
      api_host: POSTHOG_API_HOST,
      ui_host: POSTHOG_UI_HOST,
      defaults: POSTHOG_DEFAULTS,
      // Disable features you don't need to reduce script loading
      disable_surveys: true, // Disable surveys if not using them (saves 31 KiB)
      autocapture: true, // Set to false to disable autocapture and save 6 KiB
      capture_pageview: true,
      capture_pageleave: true,
      // Cache configuration for better performance
      persistence: 'localStorage', // Use localStorage for persistence (caches user properties and session data)
      persistence_name: 'ph_flmfun', // Custom storage key
    });
    initialized = true;
  }

  return { posthog };
}

export default usePostHog;
